import { render, staticRenderFns } from "./browser_project.vue?vue&type=template&id=32f3ed05&scoped=true&"
import script from "./browser_project.vue?vue&type=script&lang=js&"
export * from "./browser_project.vue?vue&type=script&lang=js&"
import style0 from "./browser_project.vue?vue&type=style&index=0&id=32f3ed05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3ed05",
  null
  
)

export default component.exports